const CUSTOM_PROPERTY_PREFIX = "--color-"

module.exports = {
  CUSTOM_PROPERTY_PREFIX,
}
